import { createContext } from "react";

export type AccordionContextState = {
  /**
   * property for whether the accordion is current in expanded state
   */
  expanded: boolean;
  /**
   * property for whether the accordion is disabled
   */
  disabled: boolean;
  /**
   * property that request the toggling of expanded state
   */
  toggle: () => void;
};

export const AccordionContext = createContext({} as AccordionContextState);

if (process.env.NODE_ENV !== "production") {
  AccordionContext.displayName = "AccordionContext";
}

export default AccordionContext;
